export default __webpack_public_path__ + "static/media/czechy.586a0d13.jpg";